import { render, staticRenderFns } from "./CallsTable.vue?vue&type=template&id=f8dddd08&scoped=true&"
import script from "./CallsTable.vue?vue&type=script&lang=js&"
export * from "./CallsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dddd08",
  null
  
)

export default component.exports